import { Box } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";

interface CarouselArrowsProps {
  onPrevClick: (e: React.MouseEvent) => void;
  onNextClick: (e: React.MouseEvent) => void;
  show?: boolean;
  leftPosition?: string;
  rightPosition?: string;
  topPosition?: string;
  arrowSize?: string;
  backgroundColor?: string;
  iconColor?: string;
  iconSize?: string;
}

const CarouselArrows = ({
  onPrevClick,
  onNextClick,
  show = true,
  leftPosition = "12px",
  rightPosition = "12px",
  topPosition = "50%",
  arrowSize = "32px",
  backgroundColor = "rgba(255, 255, 255, 0.9)",
  iconColor = "#333",
  iconSize = "18px",
}: CarouselArrowsProps) => {
  if (!show) return null;

  const arrowBaseStyles = {
    position: "absolute",
    top: topPosition,
    transform: "translateY(-50%)",
    zIndex: 2,
    width: arrowSize,
    height: arrowSize,
    backgroundColor: backgroundColor,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    opacity: 1,
    transition: "all 0.3s ease",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 1)",
      transform: "translateY(-50%) scale(1.1)",
    },
  };

  return (
    <>
      {/* Left Arrow */}
      <Box
        onClick={onPrevClick}
        sx={{
          ...arrowBaseStyles,
          left: leftPosition,
        }}
      >
        <ChevronLeft
          sx={{
            fontSize: iconSize,
            color: iconColor,
          }}
        />
      </Box>

      {/* Right Arrow */}
      <Box
        onClick={onNextClick}
        sx={{
          ...arrowBaseStyles,
          right: rightPosition,
        }}
      >
        <ChevronRight
          sx={{
            fontSize: iconSize,
            color: iconColor,
          }}
        />
      </Box>
    </>
  );
};

export default CarouselArrows;
